/**
 * Spring/timing presets for onboarding motion.
 *
 * Philosophy (per admin, 17 Apr 2026 + ресёрч liquid-glass):
 *   - Премиум медленно: 500-900мс для входов, не 150-200мс.
 *   - Spring с низким stiffness (120-160), damping 22-28.
 *   - Ease-out curves для duration-based анимаций (iOS feel).
 *   - Stagger 60ms между детьми контейнера.
 *   - Никаких linear easings, никаких "springy bouncy".
 *
 * Все новые анимации в онбординге берут ТОЛЬКО отсюда,
 * чтобы стиль был единообразным и не съезжал в AI-generic.
 */

/** Пружина для входа крупных элементов (экран, hero-карточка) */
export const SPRING_SCREEN = {
  type: 'spring' as const,
  stiffness: 120,
  damping: 22,
  mass: 1,
} as const;

/** Пружина для карточек/лист-айтемов */
export const SPRING_CARD = {
  type: 'spring' as const,
  stiffness: 160,
  damping: 24,
  mass: 1,
} as const;

/** Пружина для мелких элементов (чекбоксы, иконки) */
export const SPRING_POP = {
  type: 'spring' as const,
  stiffness: 280,
  damping: 26,
} as const;

/** Пружина для tap-feedback — быстрее, но всё ещё мягко */
export const SPRING_TAP = {
  type: 'spring' as const,
  stiffness: 400,
  damping: 25,
} as const;

/** Duration-based easing для экрана (700ms expo.out) */
export const EASE_SCREEN = {
  duration: 0.7,
  ease: [0.22, 1, 0.36, 1] as [number, number, number, number],
} as const;

/** iOS drawer easing для оверлеев */
export const EASE_DRAWER = {
  duration: 0.45,
  ease: [0.32, 0.72, 0, 1] as [number, number, number, number],
} as const;

/** Быстрый fade-out на exit */
export const EASE_EXIT = {
  duration: 0.28,
  ease: [0.4, 0, 1, 1] as [number, number, number, number],
} as const;

/** Stagger между детьми — 60мс, premium sequential feel */
export const STAGGER_CHILDREN = 0.06;
export const STAGGER_INITIAL_DELAY = 0.12;

/** Count-up длительность для сумм USDT */
export const COUNT_UP_DURATION = 1.2;
export const COUNT_UP_EASE = [0.22, 1, 0.36, 1] as [number, number, number, number];

/** Задержка перед стартом онбординга после первого входа (ms).
 *  Админ 17 Apr 2026: задержки быть не должно — стартуем сразу. */
export const ONBOARDING_INITIAL_DELAY_MS = 0;
